import React, {useState} from 'react';
import styles from "./popupAnalytics.module.scss";
import {useTranslation} from 'react-i18next';
import Closer from "../../../../components/UI/closer/Closer";
import {Tabs} from "antd";
import News from "./tabs/news/News";
import Expert from "./tabs/expert/Expert";
import Charts from "./tabs/charts/Charts";
import Candlestick from "./tabs/candlestick/Candlestick";
import {
  Candle,
  IAnalytics,
  IInfoAboutAdviceToAnalyticsPopup,
  IRatingUser, Languages,
  TimeFrames
} from "../../../../shared/types";
import LongCharts from "./tabs/longCharts/LongCharts";

interface Props {
  closeHandler: () => void
  infoAboutAdvice: IInfoAboutAdviceToAnalyticsPopup
  analytics: IAnalytics
  membersRating: IRatingUser[]
  quotes: Record<string, Record<TimeFrames, Candle[]>>
}

const PopupAnalytics = ({closeHandler, infoAboutAdvice, analytics, membersRating, quotes}: Props) => {

  const {t, i18n} = useTranslation();
  const lang = i18n.language as Languages

  const [newsIsActive, setNewsIsActive] = useState(false) //активность вкладки Новости
  const [expertIsActive, setExpertIsActive] = useState(false) //активность вкладки Эксперты
  const [chartsIsActive, setChartsIsActive] = useState(true) //активность вкладки Графики по стратегии
  const [longIsActive, setLongIsActive] = useState(false) //активность вкладки Долгосрочные графики
  const [candlestickIsActive, setCandlestickIsActive] = useState(false) //активность вкладки Свечные модели

  //работа табов
  const itemsTab = [
    // {
    //   key: 'news',
    //   //@ts-ignore
    //   label: t('PopupAnalyticsTabNews'),
    // },
    // {
    //   key: 'analytics',
    //   //@ts-ignore
    //   label: t('PopupAnalyticsTabAnalytics'),
    // },
    {
      key: 'charts',
      //@ts-ignore
      label: t('PopupAnalyticsTabCharts'),
    },
    {
      key: 'long',
      //@ts-ignore
      label: t('PopupAnalyticsTabLong'),
    },
    {
      key: 'candlesticks',
      //@ts-ignore
      label: t('PopupAnalyticsTabCandlesticks'),
    },
  ];
  const changeTabHandler = (key: string) => {
    if (key === 'news') {
      if (!newsIsActive) {
        setNewsIsActive(true)
        setExpertIsActive(false)
        setChartsIsActive(false)
        setLongIsActive(false)
        setCandlestickIsActive(false)
      }
    } else if (key === 'analytics') {
      if (!expertIsActive) {
        setExpertIsActive(true)
        setNewsIsActive(false)
        setChartsIsActive(false)
        setLongIsActive(false)
        setCandlestickIsActive(false)
      }
    } else if (key === 'charts') {
      if (!chartsIsActive) {
        setChartsIsActive(true)
        setNewsIsActive(false)
        setExpertIsActive(false)
        setLongIsActive(false)
        setCandlestickIsActive(false)
      }
    } else if (key === 'long') {
      if (!longIsActive) {
        setLongIsActive(true)
        setNewsIsActive(false)
        setExpertIsActive(false)
        setChartsIsActive(false)
        setCandlestickIsActive(false)
      }
    } else if (key === 'candlesticks') {
      if (!candlestickIsActive) {
        setCandlestickIsActive(true)
        setChartsIsActive(false)
        setLongIsActive(false)
        setNewsIsActive(false)
        setExpertIsActive(false)
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.wrap}>
          <Closer closeHandler={closeHandler}/>
          {/*//@ts-ignore*/}
          <p className={styles.title}>{t('PopupAnalyticsTitle')} {infoAboutAdvice.ticker}</p>
          <Tabs defaultActiveKey="1" items={itemsTab} onChange={changeTabHandler}/>
          <News
            active={newsIsActive}
            analytic={analytics.news[infoAboutAdvice.ticker]}
          />
          <Expert
            active={expertIsActive}
            analytic={analytics.expert[infoAboutAdvice.ticker]}
            membersRating={membersRating}
          />
          <Charts
            active={chartsIsActive}
            specificityOfRecomendsByStrategy={infoAboutAdvice.specificity}
            quotes={quotes[infoAboutAdvice.ticker]}
          />
          <LongCharts
            active={longIsActive}
            specificityOfRecomendsByStrategy={infoAboutAdvice.specificity}
            quotes={quotes[infoAboutAdvice.ticker]}
          />
          <Candlestick
            active={candlestickIsActive}
            analytic={analytics.candles[infoAboutAdvice.ticker]}
            specificityOfRecomendsByStrategy={infoAboutAdvice.specificity}
            quotes={quotes[infoAboutAdvice.ticker]}
          />
        </div>
      </div>
    </div>
  );
};

export default PopupAnalytics;